<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- account setting page -->
    <section id="page-account-settings">
      <div class="row nav-vertical d-flex">
        <div class="col-md-3 mb-2 mb-md-0">
          <ul
            ngbNav
            #navVertical="ngbNav"
            [(activeId)]="active"
            (navChange)="onNavChange($event)"
            class="nav nav-pills flex-column nav-left"
          >
            <!-- My Profile -->
            <li class="nav-item" [ngbNavItem]="1">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-profile"
                data-toggle="pill"
                href="#account-vertical-profile"
                aria-expanded="true"
                (click)="getMyUser()"
              >
                <i data-feather="user" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">My Profile</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- users edit media object start -->
                    <!-- users edit media object ends -->

                    <!-- form -->
                    <form
                      class="validate-form mt-2"
                      (ngSubmit)="(updateMyUserForm.form.valid)"
                      #updateMyUserForm="ngForm"
                    >
                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="myUser-firstName">First Name</label>
                            <input
                              type="text"
                              [(ngModel)]="myUser.firstName"
                              class="form-control"
                              id="myUser-firstName"
                              name="firstName"
                              placeholder="First Name"
                              [class.error]="
                                updateMyUserForm.submitted &&
                                FFirstNameRef.invalid
                              "
                              #FFirstNameRef="ngModel"
                              tabindex="1"
                              required
                            />
                            <span
                              *ngIf="
                                updateMyUserForm.submitted &&
                                FFirstNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FFirstNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="myUser-lastname">Last Name</label>
                            <input
                              type="text"
                              [(ngModel)]="myUser.lastName"
                              class="form-control"
                              id="myUser-lastname"
                              name="lastName"
                              placeholder="Last Name"
                              [class.error]="
                                updateMyUserForm.submitted &&
                                FLastNameRef.invalid
                              "
                              #FLastNameRef="ngModel"
                              tabindex="2"
                              required
                            />
                            <span
                              *ngIf="
                                updateMyUserForm.submitted &&
                                FLastNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FLastNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="myUser-e-mail">E-mail</label>
                            <input
                              type="email"
                              [(ngModel)]="myUser.email"
                              class="form-control"
                              id="myUser-e-mail"
                              name="email"
                              placeholder="Email"
                              autocomplete="off"
                              [class.error]="
                                updateMyUserForm.submitted && FEmailRef.invalid
                              "
                              #FEmailRef="ngModel"
                              tabindex="3"
                              required
                            />
                            <span
                              *ngIf="
                                updateMyUserForm.submitted && FEmailRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FEmailRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="myUser-phone">Phone</label>
                            <input
                              type="text"
                              [(ngModel)]="myUser.phoneNumber"
                              class="form-control"
                              id="myUser-phone"
                              name="phone"
                              placeholder="Phone"
                              [class.error]="
                                updateMyUserForm.submitted && FPhoneRef.invalid
                              "
                              #FPhoneRef="ngModel"
                              tabindex="4"
                              required
                            />
                            <span
                              *ngIf="
                                updateMyUserForm.submitted && FPhoneRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FPhoneRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-new-password"
                              >New Password</label
                            >
                            <div
                              class="input-group form-password-toggle input-group-merge"
                            >
                              <input
                                [type]="
                                  passwordTextTypeNew ? 'text' : 'password'
                                "
                                [(ngModel)]="myUser.password"
                                #FNewPasswordRef="ngModel"
                                id="account-new-password"
                                name="new-password"
                                class="form-control"
                                placeholder="············"
                                aria-describedby="new-password"
                                autocomplete="new-password"
                                tabindex="5"
                              />
                              <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"
                                  ><i
                                    class="feather font-small-4"
                                    [ngClass]="{
                                      'icon-eye-off': passwordTextTypeNew,
                                      'icon-eye': !passwordTextTypeNew
                                    }"
                                    (click)="togglePasswordTextTypeNew()"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-retype-new-password"
                              >Retype New Password</label
                            >
                            <div
                              class="input-group form-password-toggle input-group-merge"
                            >
                              <input
                                [type]="
                                  passwordTextTypeRetype ? 'text' : 'password'
                                "
                                class="form-control"
                                id="account-retype-new-password"
                                name="confirm-new-password"
                                placeholder="············"
                                aria-describedby="confirm-password"
                                autocomplete="new-password"
                                tabindex="6"
                                [class.error]="!alertClose"
                              />
                              <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"
                                  ><i
                                    class="feather font-small-4"
                                    [ngClass]="{
                                      'icon-eye-off': passwordTextTypeRetype,
                                      'icon-eye': !passwordTextTypeRetype
                                    }"
                                    (click)="togglePasswordTextTypeRetype()"
                                  ></i
                                ></span>
                              </div>
                            </div>
                            <span *ngIf="!alertClose" class="invalid-form">
                              <small class="form-text text-danger"
                                >Retyped new password is not the same.</small
                              >
                            </span>
                          </div>
                        </div>
                        <div
                          class="col-12 mt-75"
                          *ngIf="myUser.status == 'pending'"
                        >
                          <div class="alert alert-warning mb-50" role="alert">
                            <h4 class="alert-heading">
                              Your email is not confirmed. Please check your
                              inbox.
                            </h4>
                            <div class="alert-body">
                              <a href="javascript: void(0);" class="alert-link"
                                >Resend confirmation*</a
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="!loadingButton">
                          <button
                            type="submit"
                            class="btn btn-primary mr-1"
                            (click)="
                              submit(updateMyUserForm, 'updateMyUserForm')
                            "
                            rippleEffect
                          >
                            Save changes
                          </button>
                          <button
                            class="btn btn-outline-secondary"
                            (click)="getMyUser()"
                          >
                            Cancel
                          </button>
                        </div>
                        <div class="col-12" *ngIf="loadingButton">
                          <button
                            class="btn btn-outline-primary"
                            type="button"
                            disabled
                            rippleEffect
                          >
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span class="ml-25 align-middle">Saving...</span>
                          </button>
                        </div>
                      </div>
                    </form>
                    <!--/ form -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ My Profile -->

            <!-- Logins & Permissions -->
            <li class="nav-item" [ngbNavItem]="5" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-users"
                data-toggle="pill"
                href="#account-vertical-users"
                aria-expanded="false"
                (click)="getUsersList()"
              >
                <i data-feather="user-check" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Logins & Permissions</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- Hoverable rows -->
                    <div class="row" id="table-hover-row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header">
                            <h4 class="card-title">User List</h4>
                            <button
                              class="btn btn-primary ml-1"
                              rippleEffect
                              (click)="toggleSidebar('new-user-sidebar', null)"
                            >
                              <i
                                data-feather="plus"
                                class="d-sm-none d-inline-block mr-0 mr-sm-1"
                              ></i
                              ><span class="d-none d-sm-inline-block">Add</span>
                            </button>
                          </div>

                          <span
                            *ngIf="loading"
                            class="spinner-border spinner-border-sm"
                          ></span>

                          <div *ngIf="!loading" class="table-responsive">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Locations</th>
                                  <th>Status</th>
                                  <th>Admin</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="let user of usersList; let i = index"
                                >
                                  <!-- USERS -->
                                  <td>
                                    <span class="font-weight-bold"
                                      >{{ user.firstName }}
                                      {{ user.lastName }}</span
                                    >
                                  </td>
                                  <!-- LOCATIONS -->
                                  <td>
                                    <div class="avatar-group">
                                      <div
                                        data-toggle="tooltip"
                                        data-popup="tooltip-custom"
                                        placement="top"
                                        container="body"
                                        title=""
                                        class="avatar pull-up my-0"
                                        ngbTooltip="{{ location.locationName }}"
                                        *ngFor="
                                          let location of user.location;
                                          let i = index
                                        "
                                      >
                                        <img
                                          *ngIf="location.locationLogo != ''"
                                          [src]="location.locationLogo"
                                          alt="Avatar"
                                          height="26"
                                          width="26"
                                        />
                                        <img
                                          *ngIf="location.locationLogo == ''"
                                          src="assets/images/profile/user-uploads/location-00.png"
                                          alt="Avatar"
                                          height="26"
                                          width="26"
                                        />

                                        <span
                                          class="avatar-status"
                                          [ngClass]="{
                                            'avatar-status-online':
                                              location.locationStatus ==
                                              'active',
                                            'avatar-status-offline':
                                              location.locationStatus ==
                                              'inactive',
                                            'avatar-status-away':
                                              location.locationStatus ==
                                              'pending'
                                          }"
                                        ></span>
                                      </div>
                                    </div>
                                  </td>
                                  <!-- STATUS -->
                                  <td>
                                    <span
                                      class="badge badge-pill mr-1"
                                      [ngClass]="{
                                        'badge-light-success':
                                          user.status == 'active',
                                        'badge-light-secondary':
                                          user.status == 'inactive',
                                        'badge-light-warning':
                                          user.status == 'pending'
                                      }"
                                      >{{ user.status.toUpperCase() }}</span
                                    >
                                  </td>
                                  <!-- ADMIN -->
                                  <td style="text-align: center">
                                    <input
                                      type="checkbox"
                                      style="cursor: pointer"
                                      (click)="changeUserRole(i)"
                                      [checked]="user.role == 'Admin'"
                                      [disabled]="user.id == myUser.id"
                                    />
                                  </td>
                                  <!-- ACTIONS -->
                                  <td class="overflow-hidden">
                                    <div ngbDropdown container="body">
                                      <button
                                        type="button"
                                        class="btn btn-sm hide-arrow"
                                        ngbDropdownToggle
                                        data-toggle="dropdown"
                                      >
                                        <i data-feather="more-vertical"></i>
                                      </button>
                                      <div ngbDropdownMenu>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          (click)="
                                            toggleSidebar(
                                              'edit-user-sidebar',
                                              i
                                            )
                                          "
                                          ><i
                                            data-feather="edit-2"
                                            class="mr-50"
                                          ></i
                                          ><span>Edit</span>
                                        </a>
                                        <a
                                          ngbDropdownItem
                                          *ngIf="user.status != 'inactive'"
                                          href="javascript:void(0);"
                                          (click)="
                                            changeUserStatus(
                                              user.id,
                                              'Inactive'
                                            )
                                          "
                                          ><i
                                            data-feather="trash"
                                            class="mr-50"
                                          ></i
                                          ><span>Inactivate</span>
                                        </a>
                                        <a
                                          ngbDropdownItem
                                          *ngIf="user.status == 'inactive'"
                                          href="javascript:void(0);"
                                          (click)="
                                            changeUserStatus(user.id, 'Active')
                                          "
                                          ><i
                                            data-feather="trash"
                                            class="mr-50"
                                          ></i
                                          ><span>Activate</span>
                                        </a>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--/ Hoverable rows -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Logins & Permissions -->

            <!-- Company -->
            <li class="nav-item" [ngbNavItem]="2" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-company"
                data-toggle="pill"
                href="#account-vertical-company"
                aria-expanded="true"
              >
                <i data-feather="home" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Company</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <div class="card-header">
                      <div class="card-title">
                        <h4>Company Details</h4>
                      </div>
                    </div>

                    <!-- header media -->
                    <!--/ header media -->

                    <!-- form -->
                    <form
                      class="validate-form mt-2"
                      (ngSubmit)="(updateCompanyForm.form.valid)"
                      #updateCompanyForm="ngForm"
                    >
                      <div class="row" style="margin: 0px">
                        <div class="col-6">
                          <div class="form-group">
                            <label for="account-name">Company Name</label>
                            <input
                              type="text"
                              [(ngModel)]="customer.customerName"
                              class="form-control"
                              id="account-company"
                              name="company"
                              placeholder="Company"
                              [class.error]="
                                updateCompanyForm.submitted &&
                                FCustomerNameRef.invalid
                              "
                              #FCustomerNameRef="ngModel"
                              required
                            />
                            <span
                              *ngIf="
                                updateCompanyForm.submitted &&
                                FCustomerNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FCustomerNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label for="account-name">ABN</label>
                            <input
                              type="text"
                              [(ngModel)]="customer.ABN"
                              class="form-control"
                              id="account-company"
                              name="abn"
                              placeholder="ABN"
                              [class.error]="
                                updateCompanyForm.submitted &&
                                FCustomerABNRef.invalid
                              "
                              #FCustomerABNRef="ngModel"
                            />
                            <span
                              *ngIf="
                                updateCompanyForm.submitted &&
                                FCustomerNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FCustomerNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="card-header col-12">
                          <div class="card-title">
                            <h4>Contact Person</h4>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-address">First Name</label>
                            <input
                              type="text"
                              [(ngModel)]="customer.contactFirstName"
                              class="form-control"
                              id="account-address"
                              name="customerFirstName"
                              placeholder="First Name"
                              [class.error]="
                                updateCompanyForm.submitted &&
                                FCustomerFirstNameRef.invalid
                              "
                              #FCustomerFirstNameRef="ngModel"
                              required
                            />
                            <span
                              *ngIf="
                                updateCompanyForm.submitted &&
                                FCustomerFirstNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FCustomerFirstNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-address">Last Name</label>
                            <input
                              type="text"
                              [(ngModel)]="customer.contactLastName"
                              class="form-control"
                              id="account-address"
                              name="customerLastName"
                              placeholder="Last Name"
                              [class.error]="
                                updateCompanyForm.submitted &&
                                FCustomerLastNameRef.invalid
                              "
                              #FCustomerLastNameRef="ngModel"
                              required
                            />
                            <span
                              *ngIf="
                                updateCompanyForm.submitted &&
                                FCustomerLastNameRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FCustomerLastNameRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-e-mail">E-mail</label>
                            <input
                              type="email"
                              [(ngModel)]="customer.contactEmail"
                              class="form-control"
                              id="account-e-mail"
                              name="email"
                              placeholder="Email"
                              [class.error]="
                                updateCompanyForm.submitted &&
                                FCustomerEmailRef.invalid
                              "
                              #FCustomerEmailRef="ngModel"
                              required
                            />
                            <span
                              *ngIf="
                                updateCompanyForm.submitted &&
                                FCustomerEmailRef.invalid
                              "
                              class="invalid-form"
                            >
                              <small
                                class="form-text text-danger"
                                *ngIf="FCustomerEmailRef.errors.required"
                                >This field is required!</small
                              >
                            </span>
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label for="account-phone">Phone Number</label>
                            <input
                              type="text"
                              [(ngModel)]="customer.customerPhone"
                              #FAccountPhoneRef="ngModel"
                              class="form-control"
                              id="account-phone"
                              name="phone"
                              placeholder="Phone"
                            />
                          </div>
                        </div>
                        <div class="col-12" *ngIf="!loadingButton">
                          <button
                            type="submit"
                            class="btn btn-primary mr-1"
                            (click)="
                              submit(updateCompanyForm, 'updateCompanyForm')
                            "
                            rippleEffect
                          >
                            Save changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-outline-secondary"
                            (click)="getCustomer()"
                          >
                            Cancel
                          </button>
                        </div>
                        <div class="col-12" *ngIf="loadingButton">
                          <button
                            class="btn btn-outline-primary"
                            type="button"
                            disabled
                            rippleEffect
                          >
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span class="ml-25 align-middle">Saving...</span>
                          </button>
                        </div>
                      </div>
                    </form>
                    <!--/ form -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Company -->

            <!-- Locations -->
            <li class="nav-item" [ngbNavItem]="4" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-locations"
                data-toggle="pill"
                href="#account-vertical-locations"
                aria-expanded="false"
                (click)="getLocations()"
                [(activeId)]="active"
              >
                <i data-feather="map-pin" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Locations</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- Hoverable rows -->
                    <div class="row" id="table-hover-row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header">
                            <h4 class="card-title">Locations List</h4>
                            <button
                              class="btn btn-primary ml-1"
                              rippleEffect
                              (click)="toggleSidebar('location-sidebar', null)"
                            >
                              <i
                                data-feather="plus"
                                class="d-sm-none d-inline-block mr-0 mr-sm-1"
                              ></i
                              ><span class="d-none d-sm-inline-block">Add</span>
                            </button>
                          </div>
                          <div class="card-body"></div>
                          <div class="table-responsive">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Location</th>
                                  <th>Users</th>
                                  <th>Status</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="
                                    let location of locations;
                                    let i = index
                                  "
                                >
                                  <!-- LOCATION -->
                                  <td>
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        toggleSidebar('location-sidebar', i)
                                      "
                                    >
                                      <img
                                        *ngIf="
                                          location.locationLogo.length == 0
                                        "
                                        src="assets/images/profile/user-uploads/location-00.png"
                                        class="mr-75"
                                        height="20"
                                        width="20"
                                        alt="Angular"
                                      />
                                      <img
                                        *ngIf="location.locationLogo.length > 0"
                                        [src]="location.locationLogo"
                                        class="mr-75"
                                        height="20"
                                        width="20"
                                        alt="Angular"
                                      />
                                      <span class="font-weight-bold">{{
                                        location.locationName
                                      }}</span>
                                    </a>
                                  </td>
                                  <!-- USERS -->
                                  <td>
                                    <div class="avatar-group">
                                      <div
                                        data-toggle="tooltip"
                                        data-popup="tooltip-custom"
                                        placement="top"
                                        container="body"
                                        title=""
                                        class="avatar pull-up my-0"
                                        ngbTooltip="{{ user.firstName }} {{
                                          user.lastName
                                        }}"
                                        *ngFor="
                                          let user of location.userId;
                                          let i = index
                                        "
                                      >
                                        <img
                                          src="assets/images/profile/user-uploads/user-00.png"
                                          alt="Avatar"
                                          height="26"
                                          width="26"
                                        />
                                        <span
                                          class="avatar-status"
                                          [ngClass]="{
                                            'avatar-status-online':
                                              user.status == 'active',
                                            'avatar-status-offline':
                                              user.status == 'inactive',
                                            'avatar-status-away':
                                              user.status == 'pending'
                                          }"
                                        ></span>
                                      </div>
                                    </div>
                                  </td>
                                  <!-- STATUS -->
                                  <td>
                                    <span
                                      class="badge badge-pill mr-1"
                                      [ngClass]="{
                                        'badge-light-success':
                                          location.locationStatus == 'active',
                                        'badge-light-secondary':
                                          location.locationStatus == 'inactive',
                                        'badge-light-warning':
                                          location.locationStatus == 'pending'
                                      }"
                                      >{{
                                        location.locationStatus.toUpperCase()
                                      }}</span
                                    >
                                  </td>
                                  <!-- ACTIONS -->
                                  <td class="overflow-hidden">
                                    <div ngbDropdown container="body">
                                      <button
                                        type="button"
                                        class="btn btn-sm hide-arrow"
                                        ngbDropdownToggle
                                        data-toggle="dropdown"
                                      >
                                        <i data-feather="more-vertical"></i>
                                      </button>
                                      <div ngbDropdownMenu>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          (click)="
                                            toggleSidebar('location-sidebar', i)
                                          "
                                          ><i
                                            data-feather="edit-2"
                                            class="mr-50"
                                          ></i
                                          ><span>Edit</span>
                                        </a>
                                        <div
                                          role="separator"
                                          class="dropdown-divider"
                                          *ngIf="
                                            location.locationStatus ==
                                              'pending' &&
                                            location.merchantAccount != ''
                                          "
                                        ></div>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          *ngIf="
                                            location.locationStatus ==
                                              'pending' &&
                                            location.merchantAccount != ''
                                          "
                                          (click)="
                                            activateLocation(location.id)
                                          "
                                        >
                                          <i
                                            data-feather="power"
                                            class="mr-50"
                                          ></i>
                                          <span>Activate</span>
                                        </a>
                                        <div
                                          role="separator"
                                          class="dropdown-divider"
                                          *ngIf="
                                            location.locationStatus !=
                                            'inactive'
                                          "
                                        ></div>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          *ngIf="
                                            location.locationStatus !=
                                            'inactive'
                                          "
                                          (click)="
                                            inactivateLocation(location.id)
                                          "
                                          ><i
                                            data-feather="trash"
                                            class="mr-50"
                                          ></i
                                          ><span>Delete</span>
                                        </a>
                                        <div
                                          role="separator"
                                          class="dropdown-divider"
                                          *ngIf="
                                            location.locationStatus == 'active'
                                          "
                                        ></div>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          *ngIf="
                                            location.locationStatus == 'active'
                                          "
                                          (click)="
                                            createInviteLink(location.id)
                                          "
                                          ><i
                                            data-feather="plus"
                                            class="mr-50"
                                          ></i
                                          ><span>Create Invite Link</span>
                                        </a>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          id="sendCreateLink{{ location.id }}"
                                          style="display: none"
                                          (click)="sendCreateLink(location.id)"
                                        >
                                        </a>
                                        <input
                                          type="text"
                                          id="linkName{{ location.id }}"
                                          style="display: none"
                                        />
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          *ngFor="
                                            let link of location.inviteLinks;
                                            let i = index
                                          "
                                          (click)="copyLink(link)"
                                        >
                                          <i
                                            data-feather="link"
                                            class="mr-50"
                                          ></i>
                                          {{ link.name }}
                                        </a>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--/ Hoverable rows -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Locations -->

            <!-- Import Patients -->
            <li class="nav-item" [ngbNavItem]="11" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-import"
                data-toggle="pill"
                href="#account-vertical-import"
                aria-expanded="false"
              >
                <i data-feather="file-plus" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Import Patients</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- Hoverable rows -->
                    <div class="row" id="table-hover-row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header">
                            <h4 class="card-title">
                              Add Your Patients To SmilePass
                            </h4>
                          </div>
                          <div class="card-body">
                            <p>
                              The Patient Upload functionality simplifies the
                              process of integrating your existing patients with
                              SmilePass. This feature allows you to securely
                              upload basic patient information - such as name,
                              email, phone and date of birth - by using a
                              pre-designed template. By uploading your patient
                              list, you eliminate the need to manually input
                              those details every time they use SmilePass
                              services, like memberships or payment plans.
                              Patients added through this process will also
                              receive invitations to join your membership plans,
                              increasing engagement and enhancing their
                              experience.
                            </p>
                            <p>
                              <span class="text-bold">How It Works:</span>
                            </p>
                            <ol>
                              <li>
                                <span class="text-bold"
                                  >Download the Template:</span
                                >
                                Use the provided template to add your patient
                                information.
                              </li>
                              <li>
                                <span class="text-bold"
                                  >Fill in Basic Details:</span
                                >
                                Add the required details: name, email, phone,
                                address, and date of birth.
                              </li>
                              <li>
                                <span class="text-bold">Upload the File:</span>
                                Save the file in .csv
                                format and upload it below.
                              </li>
                              <li>
                                <span class="text-bold">Submit:</span> Click the
                                submit button, and we'll process your data.
                              </li>
                            </ol>
                            <p>
                              <span class="text-bold"
                                >Download the Template:</span
                              >
                            </p>
                            <p>
                              Use the following template to ensure your data is
                              formatted correctly.
                            </p>
                            <p>
                              <a href="javascript: void(0);" (click)="downloadCSV()">
                                <i data-feather="arrow-down-circle" class="font-medium-3"></i>
                                Template Patient List.csv
                              </a>
                            </p>

                            <p>
                              <span class="text-bold">File Upload:</span>
                            </p>
                            <p>
                              Upload your Completed File (Supported Format:
                              .csv):
                            </p>
                            <section id="file-upload" class="mb-3">
                              <div class="row">
                                <div class="col-12">
                                  <input
                                    type="file"
                                    #fileInput
                                    (change)="onFileSelected($event)"
                                    accept=".csv"
                                    style="display: none"
                                  />
                                  <button
                                    class="py-5 mb-3 text-center font-medium-5 text-uppercase file-drop-zone"
                                    style="width: 100%;"
                                    (click)="triggerFileInput()" 
                                    (fileOver)="fileOverBase($event)"
                                    (drop)="onFileDrop($event)"
                                    (dragover)="onDragOver($event)"
                                  >
                                    Drop Files Here Or Click To Upload
                                  </button>
                                </div>
                                <div class="col-12">
                                  <p *ngIf="selectedFile">
                                    Selected file name: {{ selectedFile.name }}
                                  </p>
                                  <p *ngIf="uploadProgress > 0">
                                    Progress: {{ uploadProgress }}%
                                  </p>
                                  <div
                                    *ngIf="
                                      jsonData &&
                                      jsonData.length > 0
                                    "
                                    class="mt-4 mb-2"
                                  >
                                    <h4 class="mb-2">Sample Data</h4>
                                    <table
                                      class="table table-responsive"
                                      style="max-width: 100%"
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            <p class="truncate-title">
                                              First Name
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Last Name
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Document Number
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Nationality
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Country Code
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Phone Number
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">Email</p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Address
                                            </p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">Gender</p>
                                          </th>
                                          <th>
                                            <p class="truncate-title">
                                              Date of Birth
                                            </p>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let item of jsonData.slice(0, 5)
                                          "
                                        >
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.firstName }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.lastName }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.documentNumber }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.nationality }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.countryAreaCode }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.phoneNumber }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.email }}
                                            </p>
                                          </td>
                                          <td>
                                            <p
                                              class="truncate-text"
                                              [ngbTooltip]="item.address"
                                            >
                                              {{ item.address }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{ item.gender }}
                                            </p>
                                          </td>
                                          <td>
                                            <p class="truncate-text">
                                              {{
                                                item.dob
                                              }}
                                            </p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div>
                                    <button
                                    class="btn btn-primary"
                                      (click)="uploadFile()"
                                      [disabled]="!selectedFile || isUploading"
                                    >
                                      {{
                                        isUploading ? "Uploading..." : "Send File"
                                      }}
                                    </button>
                                  </div>
                                  
                                </div>
                              </div>
                            </section>

                            <p>
                              <span class="text-bold"
                                >Privacy & Security Statement:</span
                              >
                            </p>
                            <p>
                              Your patient data is safe with SmilePass. We only
                              require basic details to help manage memberships
                              and payments. All information is stored securely
                              and complies with privacy regulations.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Import Patients -->

            <!-- Membership Builder -->
            <li class="nav-item" [ngbNavItem]="6" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-products"
                data-toggle="pill"
                href="#account-vertical-products"
                aria-expanded="false"
              >
                <i data-feather="edit" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Membership Builder</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-header" *ngIf="!loading">
                    <h4 class="card-title">Recommended Templates</h4>                    
                  </div>
                  <div class="card-body" *ngIf="!loading" >
                    <div class="row"  *ngIf="!isModelOpened">
                      <div class="mt-1 ml-2">
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="height: 120px; width: 180px;"
                          (click)="openProductSide(null)"
                          rippleEffect
                        >
                          <span
                            [data-feather]="'plus'"
                            [class]="'mr-25'"
                            [size]="40"
                          ></span
                          ><br />
                          Create New Plan
                        </button>
                      </div>
                      <div class="mt-1 ml-2" *ngFor="let model of membershipModelList | slice: 0:3; let i = index">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          style="height: 120px; width: 180px;"
                          (click)="selectModal(model, modalAddTemplate)"
                          rippleEffect
                        >
                          {{model.title}}
                        </button>
                      </div>
                    </div>
                    <div >
                      <div class="row" *ngIf="isModelOpened">
                        <div class="mt-1 ml-2">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="height: 120px; width: 180px;"
                            (click)="openTemplateSide(null)"
                            rippleEffect
                          >
                            <span
                              [data-feather]="'plus'"
                              [class]="'mr-25'"
                              [size]="40"
                            ></span
                            ><br />
                            Create New Plan
                          </button>
                        </div>
  
                        <div class="mt-1 ml-2" *ngFor="let model of membershipModelList | slice: 0:15; let i = index">
                          <button
                            type="button"
                            class="btn btn-outline-primary"
                            style="height: 120px; width: 180px;"
                            (click)="selectModal(model, modalAddTemplate)"
                            rippleEffect
                          >
                            {{model.title}}
                          </button>
                        </div>
                      </div>
                      <div class="col-12">
                        <div style="justify-self: center;" *ngIf="isModelOpened && membershipModelList.length > 3">
                          <a
                            href="javascript: void(0);"
                            (click)="switchOpenModel()"
                          >
                          <span
                            [data-feather]="'chevron-up'"
                            [class]="'mr-25'"
                            [size]="40"
                          ></span>
                          </a>
                        </div>
                        <div style="justify-self: center;" *ngIf="!isModelOpened && membershipModelList.length > 3">                          
                          <a
                            href="javascript: void(0);"
                            (click)="switchOpenModel()"

                          >
                          <span
                          [data-feather]="'chevron-down'"
                          [class]="'mr-25'"
                          [size]="40"
                        ></span>
                          </a>

                          
                        </div>

                      </div>
                    </div>

                  </div>

                </div>

                <div class="content-detached" *ngIf="!loading">
                  <div class="content-body">
                    <!-- E-commerce Head Section Starts -->
                    <section
                      id="ecommerce-searchbar"
                      class="ecommerce-searchbar"
                    >
                      <div class="row mt-1">
                        <div class="col-sm-12">
                          <div class="input-group input-group-merge">
                            <input
                              type="text"
                              class="form-control search-product"
                              id="shop-search"
                              placeholder="Search Plan"
                              aria-label="Search..."
                              aria-describedby="shop-search"
                              [(ngModel)]="searchMembership"
                              #FSearchMembershipRef="ngModel"
                              name="searchMembership"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text"
                                ><i data-feather="search" class="text-muted"></i
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Head Section Starts -->

                    <!-- E-commerce Products Starts -->
                    <section
                      id="ecommerce-products"
                      style="margin-top: 2rem"
                      [ngClass]="
                        gridViewRef === true ? 'grid-view' : 'list-view'
                      "
                    >
                      <div class="row">
                        <div
                          class="col-lg-4 col-md-6 col-sm-12"
                          *ngFor="
                            let product of products.plans
                              | filter : searchMembership : 'title'
                              | slice
                                : (page - 1) * pageSize
                                : (page - 1) * pageSize + pageSize
                          "
                        >
                          <app-product-item
                            class="card ecommerce-card"
                            style="padding: 0 10px 10px 10px; overflow: hidden"
                            [product]="product"
                            (newItemEvent)="openProductSide(product.id)"
                          ></app-product-item>
                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Products Ends -->

                    <!-- E-commerce Pagination Starts -->
                    <section id="products-pagination">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="d-flex justify-content-center">
                            <ngb-pagination
                              [collectionSize]="
                                (
                                  products.plans
                                  | filter : searchMembership : 'title'
                                ).length
                              "
                              [(page)]="page"
                              [maxSize]="5"
                              [pageSize]="6"
                              [rotate]="true"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                            >
                              <!-- Custom pagination icons -->
                              <ng-template ngbPaginationPrevious
                                ><span
                                  [data-feather]="'chevron-left'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                              <ng-template ngbPaginationFirst
                                ><span
                                  [data-feather]="'chevrons-left'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                              <ng-template ngbPaginationNext
                                ><span
                                  [data-feather]="'chevron-right'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span
                              ></ng-template>
                              <ng-template ngbPaginationLast
                                ><span
                                  [data-feather]="'chevrons-right'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                            </ngb-pagination>
                          </div>
                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Pagination Ends -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Membership Builder -->

            <!-- Payment Plan Builder -->
            <li class="nav-item" [ngbNavItem]="12" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-templates"
                data-toggle="pill"
                href="#account-vertical-products"
                aria-expanded="false"
              >
                <i data-feather="edit" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Payment Plan Builder</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div class="card-header" *ngIf="!loading">
                    <h4 class="card-title">Recommended Templates</h4>                    
                  </div>
                  <div class="card-body" *ngIf="!loading" >
                    <div class="row"  *ngIf="!isModelOpened">
                      <div class="mt-1 ml-2">
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="height: 120px; width: 180px;"
                          (click)="openTemplateSide(null)"
                          rippleEffect
                        >
                          <span
                            [data-feather]="'plus'"
                            [class]="'mr-25'"
                            [size]="40"
                          ></span
                          ><br />
                          Create New Plan
                        </button>
                      </div>
                      <div class="mt-1 ml-2" *ngFor="let model of templatesModelList | slice: 0:3; let i = index">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          style="height: 120px; width: 180px;"
                          (click)="selectModal(model, modalAddTemplate)"
                          rippleEffect
                        >
                          {{model.title}}
                        </button>
                      </div>
                    </div>
                    <div >
                      <div class="row" *ngIf="isModelOpened">
                        <div class="mt-1 ml-2">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="height: 120px; width: 180px;"
                            (click)="openTemplateSide(null)"
                            rippleEffect
                          >
                            <span
                              [data-feather]="'plus'"
                              [class]="'mr-25'"
                              [size]="40"
                            ></span
                            ><br />
                            Create New Plan
                          </button>
                        </div>
  
                        <div class="mt-1 ml-2" *ngFor="let model of templatesModelList | slice: 0:15; let i = index">
                          <button
                            type="button"
                            class="btn btn-outline-primary"
                            style="height: 120px; width: 180px;"
                            (click)="selectModal(model, modalAddTemplate)"
                            rippleEffect
                          >
                            {{model.title}}
                          </button>
                        </div>
                      </div>
                      <div class="col-12">
                        <div style="justify-self: center;" *ngIf="isModelOpened">
                          <a
                            href="javascript: void(0);"
                            (click)="switchOpenModel()"
                          >
                          <span
                            [data-feather]="'chevron-up'"
                            [class]="'mr-25'"
                            [size]="40"
                          ></span>
                          </a>
                        </div>
                        <div style="justify-self: center;" *ngIf="!isModelOpened">                          
                          <a
                            href="javascript: void(0);"
                            (click)="switchOpenModel()"

                          >
                          <span
                          [data-feather]="'chevron-down'"
                          [class]="'mr-25'"
                          [size]="40"
                        ></span>
                          </a>

                          
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

                <div class="content-detached" *ngIf="!loading">
                  <div class="content-body">
                    <!-- E-commerce Head Section Starts -->
                    <section
                      id="ecommerce-searchbar"
                      class="ecommerce-searchbar"
                    >
                      <div class="row mt-1">
                        <div class="col-sm-12">
                          <div class="input-group input-group-merge">
                            <input
                              type="text"
                              class="form-control search-product"
                              id="shop-search"
                              placeholder="Search Plan"
                              aria-label="Search..."
                              aria-describedby="shop-search"
                              [(ngModel)]="searchTemplate"
                              #FSearchTemplateRef="ngModel"
                              name="searchTemplate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text"
                                ><i data-feather="search" class="text-muted"></i
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Head Section Starts -->

                    <!-- E-commerce Templates Starts -->
                    <section
                      id="ecommerce-templates"
                      style="margin-top: 2rem"
                      [ngClass]="
                        gridViewRef === true ? 'grid-view' : 'list-view'
                      "
                    >
                      <div class="row">
                        <div
                          class="col-lg-4 col-md-6 col-sm-12"
                          *ngFor="
                            let template of templates
                              | filter : searchTemplate : 'title'
                              | slice
                                : (page - 1) * pageSize
                                : (page - 1) * pageSize + pageSize
                            ; let i = index
                          "
                        >
                        <div
                          class="card ecommerce-card"
                          style="padding: 0 10px 10px 10px; overflow: hidden"
                        >
                          <!-- Ecommerce Item -->
                          <div class="row new-members-box">
                            <div class="col-8">
                              <p style="margin-top: 10px;">Active</p>
                            </div>
                            <div class="col-4">
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  (click)="changeTemplateStatus(template.id)"
                                  id="statusTemplateSwitch{{ template.id }}"
                                  [checked]="template.status == 'active'"
                                />
                                <label class="custom-control-label" for="statusTemplateSwitch{{ template.id }}" style="margin-top: 10px;">
                                  <span class="switch-icon-left"><i data-feather="check"></i></span>
                                  <span class="switch-icon-right"><i data-feather="x"></i></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                          </div>
                          <div style="min-height: 100px;">
                            <div class="card-body plan-body">
                              <h6 class="item-name">
                                <a class="text-body" style="cursor: default"> {{ template.title }}</a>
                              </h6>
                            </div>                    
                            <div class="benefits">
                              <ul>
                                <div *ngFor="let detail of template.descriptions; let i = index">
                                  <li>
                                    <i data-feather="check"></i>
                                      {{ detail }}
                                  </li>
                                </div>
                              </ul>
                            </div>
                            <div class="item-options text-center" style="margin: 10px">
                              <button
                                type="submit"
                                *ngIf="!loadingButton"
                                class="btn btn-primary mr-1"
                                (click)="openTemplateSide(i)"
                                rippleEffect
                              >
                                <i data-feather="edit" class="mr-25"></i> Edit
                              </button>
                            
                              <button
                                class="btn btn-outline-primary"
                                *ngIf="loadingButton"
                                type="button"
                                disabled
                                rippleEffect
                              >
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span class="ml-25 align-middle">Saving...</span>
                              </button>
                            </div>
                          </div>
                          <!--/ Ecommerce Item -->
                        
                        </div>

                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Templates Ends -->

                    <!-- E-commerce Pagination Starts -->
                    <section id="templates-pagination">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="d-flex justify-content-center">
                            <ngb-pagination
                              [collectionSize]="
                                (
                                  templates
                                  | filter : searchTemplate : 'title'
                                ).length
                              "
                              [(page)]="page"
                              [maxSize]="5"
                              [pageSize]="6"
                              [rotate]="true"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                            >
                              <!-- Custom pagination icons -->
                              <ng-template ngbPaginationPrevious
                                ><span
                                  [data-feather]="'chevron-left'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                              <ng-template ngbPaginationFirst
                                ><span
                                  [data-feather]="'chevrons-left'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                              <ng-template ngbPaginationNext
                                ><span
                                  [data-feather]="'chevron-right'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span
                              ></ng-template>
                              <ng-template ngbPaginationLast
                                ><span
                                  [data-feather]="'chevrons-right'"
                                  [class]="'font-weight-bolder'"
                                  [size]="18"
                                ></span>
                              </ng-template>
                            </ngb-pagination>
                          </div>
                        </div>
                      </div>
                    </section>
                    <!-- E-commerce Pagination Ends -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Payment Plan Builder -->
            

            <!-- Promo Code Builder -->
            <li class="nav-item" [ngbNavItem]="7" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-products"
                data-toggle="pill"
                href="#account-vertical-products"
                aria-expanded="false"
              >
                <i data-feather="tag" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Custom Discounts & Code</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div class="card-header" style="justify-content: center">
                    <h4 class="card-title">
                      Referral Program & Dependent Discounts
                    </h4>
                  </div>
                  <div class="card-body" style="text-align: center">
                    <p style="font-size: 13px">
                      Customise and adjust discounts for your referral program
                      and dependents added by patients. Reward referrals and
                      offer tailored benefits for families to enhance loyalty
                      and satisfaction within your membership program.
                    </p>
                    <button
                      class="btn btn-primary ml-1"
                      rippleEffect
                      (click)="openDiscountSetting(modalDiscounts)"
                    >
                      <i
                        data-feather="plus"
                        class="d-sm-none d-inline-block mr-0 mr-sm-1"
                      ></i
                      ><span class="d-none d-sm-inline-block"
                        >Manage Discounts</span
                      >
                    </button>
                  </div>
                </div>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- Hoverable rows -->
                    <div class="row" id="table-hover-row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header">
                            <h4 class="card-title">Promo Code List</h4>
                            <button
                              class="btn btn-primary ml-1"
                              rippleEffect
                              (click)="toggleSidebar('coupon-sidebar', null)"
                            >
                              <i
                                data-feather="plus"
                                class="d-sm-none d-inline-block mr-0 mr-sm-1"
                              ></i
                              ><span class="d-none d-sm-inline-block">Add</span>
                            </button>
                          </div>
                          <div class="card-body"></div>
                          <div class="table-responsive">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Code</th>
                                  <th>Status</th>
                                  <th>Active/View</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  *ngFor="
                                    let coupon of promoCodes;
                                    let i = index
                                  "
                                >
                                  <!-- NAME -->
                                  <td>
                                    <a
                                      href="javascript:void(0);"
                                      (click)="
                                        toggleSidebar('coupon-sidebar', i)
                                      "
                                    >
                                      <span class="font-weight-bold">{{
                                        coupon.name
                                      }}</span>
                                    </a>
                                  </td>
                                  <!-- CODE -->
                                  <td>
                                    <h6>{{ coupon.code.toUpperCase() }}</h6>
                                  </td>
                                  <!-- STATUS -->
                                  <td>
                                    <span
                                      class="badge badge-pill mr-1"
                                      [ngClass]="{
                                        'badge-light-success':
                                          coupon.status == 'active',
                                        'badge-light-secondary':
                                          coupon.status == 'inactive',
                                        'badge-light-warning':
                                          coupon.status == 'pending'
                                      }"
                                      >{{ coupon.status.toUpperCase() }}</span
                                    >
                                  </td>
                                  <!-- REPORT -->
                                  <td>
                                    <p>
                                      {{ coupon.report.activation_counter }}/{{
                                        coupon.report.visualization_counter
                                      }}
                                    </p>
                                  </td>
                                  <!-- ACTIONS -->
                                  <td class="overflow-hidden">
                                    <div ngbDropdown container="body">
                                      <button
                                        type="button"
                                        class="btn btn-sm hide-arrow"
                                        ngbDropdownToggle
                                        data-toggle="dropdown"
                                      >
                                        <i data-feather="more-vertical"></i>
                                      </button>
                                      <div ngbDropdownMenu>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          (click)="
                                            toggleSidebar('coupon-sidebar', i)
                                          "
                                          ><i
                                            data-feather="edit-2"
                                            class="mr-50"
                                          ></i
                                          ><span>Edit</span>
                                        </a>
                                        <div
                                          role="separator"
                                          class="dropdown-divider"
                                          *ngIf="coupon.status == 'pending'"
                                        ></div>
                                        <a
                                          ngbDropdownItem
                                          href="javascript:void(0);"
                                          *ngIf="coupon.status == 'pending'"
                                          (click)="activateCoupon(coupon)"
                                        >
                                          <i
                                            data-feather="power"
                                            class="mr-50"
                                          ></i>
                                          <span>Activate</span>
                                        </a>
                                        <!-- <div role="separator" class="dropdown-divider" *ngIf="coupon.status != 'pending'"></div> -->
                                        <!-- <a ngbDropdownItem href="javascript:void(0);" *ngIf="coupon.status != 'pending'" (click)="createInviteLink(location.id)"
                                          ><i data-feather="info" class="mr-50"></i><span>Report</span>
                                        </a>                                        -->
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--/ Hoverable rows -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Promo Code Builder -->

            <!-- Billing and Payout -->
            <li class="nav-item" [ngbNavItem]="8" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-locations"
                data-toggle="pill"
                href="#account-vertical-locations"
                aria-expanded="false"
                (click)="getLocations()"
                [(activeId)]="active"
              >
                <i data-feather="file-text" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Billing and Payout</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">

                  <div class="card-body" *ngIf="loading" style="align-self: center;">
                    <div class="spinner-border mr-50" style="width: 3rem; height: 3rem;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <div class="card-body" *ngIf="!loading">
                    <!-- Hoverable rows -->
                    <div class="row" id="table-hover-row">
                      <div class="col-12">
                        
                        <div class="card">
                          <div class="card-header">
                            <h4 class="card-title">Payment Details</h4>
                            
                            
                          </div>
                          <div>
                            <app-payment-method 
                            [paymentMethod]="statement.paymentMethod" 
                            [customer]="customer"
                            ></app-payment-method>
                            
                          </div>
                      
                          <div class="card-header">
                            <h4 class="card-title">Payment History</h4>
                                        
                          </div>
                          <div class="card-body">
                          </div>
                          <div class="table-responsive">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Location</th>
                                  <th>Date</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let history of statement.paymentsHistory; let i = index;">
                                  <!-- USERS -->
                                  <td>
                                    <div>
                                      <div
                                        
                                        
                                      >
                                        
                                        <a href="javascript:void(0);"

                                        (click)="openInvoice(history.id, history.type)"
                                      
                                        
                                      >{{ history.name }}</a>
                                      </div>
                                    </div>
                                  </td>
                                  <!-- LOCATION -->
                                  <td>
                                   
                                    <span>{{ history.location }}</span>
                                    
                                  </td>
                                  
                                  <!-- DATE -->
                                  <td>
                                    <span
                                      
                                    >{{history.date}}</span>

                                  </td>
                                  <!-- AMOUNT -->
                                  <td>
                                    <span
                                      
                                    >{{history.amount | currency:'USD':'symbol':'1.2-2' }}</span>

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--/ Hoverable rows -->
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Billing and Payout -->

            <!-- Promo Code Builder -->
            <li class="nav-item" [ngbNavItem]="9" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-products"
                data-toggle="pill"
                [routerLink]="'/apps/e-commerce/shop/'"
                aria-expanded="false"
              >
                <i data-feather="shopping-cart" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Promotional Material</span>
              </a>
            </li>
            <!--/ Promo Code Builder -->

            <!-- Subscription Manager -->
            <li class="nav-item" [ngbNavItem]="10" *ngIf="isAdmin">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="account-pill-products"
                data-toggle="pill"
                href="#account-vertical-products"
                aria-expanded="false"
              >
                <i data-feather="package" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">Subscription</span>
              </a>
              <ng-template ngbNavContent>
                <div class="card">
                  <div
                    class="card-body"
                    *ngIf="loading"
                    style="align-self: center"
                  >
                    <div
                      class="spinner-border mr-50"
                      style="width: 3rem; height: 3rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                <div class="content-wrapper card container-xxl p-0">
                  <div class="content-body card-body" *ngIf="!loading">
                    <section id="pricing-plan">
                      <!-- title text and switch button -->
                      <div class="text-center">
                        <h2 class="mt-5">Your Plan</h2>
                        <div
                          class="d-flex align-items-center justify-content-center mb-5 pb-50"
                        >
                          <div
                            class="btn-outline-primary round"
                            style="padding: 0.1rem"
                          >
                            <button
                              [ngClass]="
                                paymentPeriod == 'monthly'
                                  ? 'btn-primary'
                                  : 'btn-flat-primary'
                              "
                              class="btn round"
                              rippleEffect
                              (click)="switchPeriod(false, 'monthly')"
                              id="priceSwitch"
                              name="priceSwitch"
                            >
                              Monthly
                            </button>
                            <button
                              [ngClass]="
                                paymentPeriod == 'annually'
                                  ? 'btn-primary'
                                  : 'btn-flat-primary'
                              "
                              class="btn round"
                              rippleEffect
                              (click)="switchPeriod(true, 'annually')"
                              id="priceSwitch"
                              name="priceSwitch"
                            >
                              Yearly(save 25%)
                            </button>
                          </div>
                        </div>
                      </div>
                      <!--/ title text and switch button -->

                      <!-- pricing plan cards -->
            
                          <div class="row" >
                            <!-- free plan -->

                            <div class="col-12 col-md-3" style="padding: 0px 5px 0px 5px;" *ngFor="
                            let subscription of subscriptions; let i = index;">
                              <div class="card basic-pricing text-center inner-card" [ngClass]="{
                                'popular': subscription.popular === true
                              }" >
                                <div
                                  *ngIf="subscription.popular"
                                  class="text-center card-header popular-title"
                                  style="
                                  justify-content: center;
                                  padding: 0px;"
                                >
                                  <p style="color: white; position: absolute; bottom: -14px;">
                                    Most Popular
                                  </p>
                                </div>
                                <div class="pt-2" *ngIf="!subscription.popular">

                                </div>
                                <div class="card-body pricing-card" style="margin: 10px;">
                                  <h3>{{ subscription.title }}</h3>
                                  <div class="annual-plan" style="height: 50px; " >
                                    <div class="plan-price mt-2">
                                      <div style="padding-right: 5px;"
                                      *ngIf="subscription.price.monthly.perMonth != null"
                                      >
                                        <sup 
                                          class="font-medium-1 font-weight-bold text-primary"
                                          >$
                                        </sup>
                                        <span
                                          *ngIf="paymentPeriod == 'monthly'"
                                          class="pricing-basic-value font-weight-bolder text-primary"
                                          >{{ subscription.price.monthly.perMonth }}</span
                                        >
                                        <span
                                        *ngIf="paymentPeriod == 'annually'"
                                        class="pricing-basic-value font-weight-bolder text-primary"
                                        >{{ subscription.price.annually.perMonth }}</span
                                      >

                                      </div>
                                      <div 
                                      *ngIf="subscription.price.monthly.perMonth != null">
                                          <p
                                            style="text-align: left; margin: 0px;"
                                            class="pricing-duration text-body font-small-2 font-weight-bold"
                                            >
                                            {{subscription.priceDetails[0]}}
                                            <br>
                                            {{subscription.priceDetails[1]}}
                                          </p> 
                                      </div>
                                      <div style="padding-right: 5px;"
                                      *ngIf="subscription.price.monthly.perMonth == null"
                                      >
                                        <span
                                          class="pricing-basic-value font-weight-bolder text-primary"
                                          style="font-size: 36px;"
                                          >Custom
                                        </span>
                                      </div>

                                    </div>
                                   
                                    <small
                                      class="annual-pricing text-muted"
                                      *ngIf="paymentPeriod == 'annually' && subscription.price.monthly.perMonth != null && subscription.price.monthly.perMonth > 0"
                                    >
                                      *Paid annually.
                                    </small>
                                      
                                  </div>
                                  
                                  <div style="height: 80px; ">
                                    <span class=" mt-3 text-muted" style="font-size: 10px;">
                                      {{ subscription.subtitle }}
                                    </span>
                                  </div>

                                  <div *ngIf="subscription.price.monthly.perMonth != null" style="height: 100px;">
                                    <p style="font-weight: bold; 
                                    padding-top: 20px ;   
                                    font-size: 10px;
                                    line-height: 1.5; text-align: left;
                                  
                                  ">
                                      Transaction fees starting at
                                    </p>
  
                                    <div class="fee-total-item one-line ">
                                      <p class="fee-total-title" ><b>Membership:</b></p>
                                      <p class="fee-total-amount">{{subscription.fees.membership}}%</p>
                                    </div>
                                    <div class="fee-total-item one-line ">
                                      <p class="fee-total-title" ><b>Other Payments:</b></p>
                                      <p class="fee-total-amount">{{subscription.fees.other}}%</p>
                                    </div>
                                  </div>
                                  <div *ngIf="subscription.price.monthly.perMonth == null"  style="height: 100px;">
                                    <p style="font-weight: bold; 
                                    padding-top: 20px ;   
                                    font-size: 10px;
                                    line-height: 1.5; text-align: justify;                                  
                                  ">
                                      Get most competitive fees <br>
                                      <span class=" mt-3 text-muted" style="font-weight: 500">
                                        Design a custom package – available for businesses with large payments volume or unique business models.                                      </span>
                                    </p>

                                  </div>


                                  <hr />
                                  <div>
                                    <p style="font-weight: bold; 
                                     font-size: 10px;
                                      line-height: 1.5; text-align: left;
                                      white-space: nowrap;
                                    
                                    ">
                                      <span *ngIf="i > 0">
                                        Everything in {{subscriptions[i-1].title}} plus:
                                      </span>
                                      <span *ngIf="i == 0">
                                        Main benefits:
                                      </span>
                                    </p>
                                  

                                  </div>
                                  <div class="benefits" style="height: 120px; ">
                                    <ul
                                      class="text-left"
                                    >
                                      <li style="line-height: 1.5rem;"
                                        *ngFor="
                                          let planBenefitsRef of subscription.planBenefits
                                        "
                                      >
                                        <i data-feather="check"></i>

                                        {{ planBenefitsRef }}
                                      </li>
                                    </ul>
                                  </div>
                                  <div class="col align-self-end">
                                    <button
                                      class="btn btn-block disabled btn-outline-primary mt-3 round"
                                      rippleEffect
                                      style="cursor:default; font-size: 12px;"
                                      *ngIf="subscription.active && subscription.planCycle == paymentPeriod"
                                    >
                                      ACTIVE
                                    </button>
                                    <button
                                    class="btn btn-block btn-primary mt-3 round"
                                      rippleEffect
                                      style="font-size: 12px;"
                                      *ngIf="subscription.price.monthly.perMonth != null && !(subscription.active && subscription.planCycle == paymentPeriod)"
                                      (click)="upgradeRequest(i)"
                                      [disabled]="this.loadingButton"
                                      >
                                      <span
                                        *ngIf="this.loadingButton"
                                        class="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      SELECT
                                    </button>
                                    <button
                                    class="btn btn-block btn-primary mt-3 round"
                                      rippleEffect
                                      style="font-size: 12px;"
                                      *ngIf="subscription.price.monthly.perMonth == null"
                                      (click)="upgradeRequest(i)"
                                      [disabled]="this.loadingButton"
                                    >
                                      CONTACT US
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                      <!--/ pricing plan cards -->
                    </section>
                  </div>
                </div>
              </ng-template>
            </li>
            <!--/ Subscription Manager -->
          </ul>
        </div>
        <div [ngbNavOutlet]="navVertical" class="col-12 col-md-9"></div>
      </div>
    </section>
    <!--/ account setting page -->
  </div>

  <!-- Modal -->
  <ng-template #modalDiscounts let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel1">Manage Discounts</h4>
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="modal-body row"
      tabindex="0"
      ngbAutofocus
      style="height: 400px; overflow-y: auto"
    >
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>NAME</th>
              <th>STATUS</th>
              <th>MEMBERSHIP DISCOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- NAME -->
              <td>
                <h5>Dependent Program</h5>
              </td>
              <!-- STATUS -->
              <td>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    (click)="switchDiscountSettings('dependent')"
                    id="dependentOption"
                    [checked]="
                      this.currentLocation.settings.dependent_discount.isActive
                    "
                  />
                  <label
                    class="custom-control-label"
                    for="dependentOption"
                    style="margin-top: 10px"
                  >
                    <span class="switch-icon-left"
                      ><i data-feather="check"></i
                    ></span>
                    <span class="switch-icon-right"
                      ><i data-feather="x"></i
                    ></span>
                  </label>
                </div>
              </td>
              <!-- MEMBERSHIP -->
              <td>
                <div class="input-group input-group-merge" style="width: 100px">
                  <div class="input-group-prepend" style="cursor: default">
                    <span class="input-group-text"
                      ><span [data-feather]="'percent'"></span
                    ></span>
                  </div>
                  <input
                    type="number"
                    min="0"
                    step="0.1"
                    id="dependent_discount3"
                    [disabled]="
                      !this.currentLocation.settings.dependent_discount.isActive
                    "
                    name="dependent_discount3"
                    #FDependentDiscountRef3="ngModel"
                    [(ngModel)]="
                      this.currentLocation.settings.dependent_discount
                        .membership_percentage
                    "
                    placeholder="%"
                    aria-label="Amount (to the nearest dollar)"
                    class="form-control"
                    style="text-align: center"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th colspan="3" style="border: black">
                <small style="font-size: 10px">
                  The chosen percentage applies to each dependent and
                  accumulates for the account holder. For example, a 10%
                  discount with 3 dependents gives the account holder a 30%
                  membership discount, while each dependent gets 10%.
                </small>
              </th>
            </tr>
            <tr>
              <!-- NAME -->
              <td>
                <h5>Referral Program</h5>
              </td>
              <!-- STATUS -->
              <td>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    (click)="switchDiscountSettings('referral')"
                    id="referralOption"
                    [checked]="
                      this.currentLocation.settings.member_referral.isActive
                    "
                  />
                  <label
                    class="custom-control-label"
                    for="referralOption"
                    style="margin-top: 10px"
                  >
                    <span class="switch-icon-left"
                      ><i data-feather="check"></i
                    ></span>
                    <span class="switch-icon-right"
                      ><i data-feather="x"></i
                    ></span>
                  </label>
                </div>
              </td>
              <!-- MEMBERSHIP -->
              <td>
                <div class="input-group input-group-merge" style="width: 100px">
                  <div class="input-group-prepend" style="cursor: default">
                    <span class="input-group-text"
                      ><span [data-feather]="'percent'"></span
                    ></span>
                  </div>
                  <input
                    type="number"
                    min="0"
                    step="0.1"
                    id="member_referral3"
                    [disabled]="
                      !this.currentLocation.settings.member_referral.isActive
                    "
                    name="member_referral3"
                    #FMemberReferralRef3="ngModel"
                    [(ngModel)]="
                      this.currentLocation.settings.member_referral
                        .membership_percentage
                    "
                    placeholder="%"
                    aria-label="Amount (to the nearest dollar)"
                    class="form-control"
                    style="text-align: center"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th colspan="3" style="border: black">
                <small style="font-size: 10px">
                  Set the referral discount percentage offered to members and
                  their referrals. Members receive this discount per active
                  referral for 12 months, while referred friends enjoy for as
                  long as they remain active. For example, setting 10% means a
                  member with 2 referrals gets 20% off their membership for 12
                  months, while each referred friend gets 10% off.
                </small>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer" style="align-self: center">
      <button
        type="button"
        class="btn btn-primary"
        (click)="modal.close('Save')"
        (click)="saveDiscountSetup()"
        tabindex="8"
        rippleEffect
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="modal.close('Cancel')"
        (click)="selectLocation(null)"
        tabindex="8"
        rippleEffect
      >
        Cancel
      </button>
    </div>
  </ng-template>
  <!-- / Modal -->

  <!-- Modal Add Template -->
  <ng-template #modalAddTemplate let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel4">Recommended Template</h4>
    </div>
    <div class="modal-body">
      <h4>{{selectedModal.title}}</h4>
      <p>{{selectedModal.description}}</p>

      <div class="row">
        <div class="col-6">
          <div class="benefits">
            <ul>
              <div *ngFor="let detail of selectedModal.details | slice: 0:5; let i = index">
                <li>
                  <i data-feather="check"></i>
                    {{ detail }}
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="col-6">
          <div class="benefits">
            <ul>
              <div *ngFor="let detail of selectedModal.details | slice: 5:12; let i = index">
                <li>
                  <i data-feather="check"></i>
                    {{ detail }}
                </li>
              </div>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-primary" (click)="useTemplate('instalment', selectedModal.id)" [disabled]="loadingButton"
          rippleEffect>
          <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
          <span>Use Template</span></button
        >        

        <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Cancel')" [disabled]="loadingButton" rippleEffect>
          <span>Cancel</span></button
        >
    </div>
  </ng-template>
  <!-- / Modal Delete Item -->


  <!-- New User Sidebar -->
  <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="new-user-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-new-user-sidebar
      (newItemEvent)="getUsersList()"
      [currentUser]="currentUser"
      [locations]="activeLocations"
    >
    </app-new-user-sidebar>
  </core-sidebar>
  <!--/ New User Sidebar -->

  <!-- Edit User Sidebar -->
  <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="edit-user-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-edit-user-sidebar
      (newItemEvent)="getUsersList()"
      [currentUser]="currentUser"
      [locations]="locations"
    ></app-edit-user-sidebar>
  </core-sidebar>
  <!--/ New User Sidebar -->

  <!-- Location Sidebar -->
  <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="location-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-location-sidebar
      (newItemEvent)="getLocations()"
      [currentLocation]="currentLocation"
    ></app-location-sidebar>
  </core-sidebar>
  <!--/ Location Sidebar -->

    <!-- Location Sidebar -->
    <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="template-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-template-sidebar
      (newItemEvent)="getTemplates()"
      [currentTemplate]="currentTemplate"
      [locations]="activeLocations"
    ></app-template-sidebar>
  </core-sidebar>
  <!--/ Location Sidebar -->

  <!-- Edit or New Product Sidebar -->
  <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="product-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-product-sidebar
      (newItemEvent)="getProductsList()"
      (loadingChange)="onLoadingChange($event)"
      [currentProduct]="currentProduct"
      [locations]="activeLocations"
      [rows]="rows"
      [groups]="this.products.groups"
    ></app-product-sidebar>
  </core-sidebar>
  <!--/ Edit or New Product Sidebar -->

  <!-- Coupon Sidebar -->
  <core-sidebar
    class="modal modal-slide-in sidebar-todo-modal fade"
    name="coupon-sidebar"
    overlayClass="modal-backdrop"
  >
    <app-coupon-sidebar
      (newItemEvent)="getCouponList()"
      [currentCoupon]="currentCoupon"
      [plans]="plans.plans"
    >
    </app-coupon-sidebar>
  </core-sidebar>
  <!--/ Coupon Sidebar -->
</div>
